import {Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, InputLabel, MenuItem, Select, TextField, Tooltip} from "@mui/material";
import React, {useState} from "react";
import {Delete} from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import { TextRequired } from "../../../../Utils/ElementsHtmlUtil";

const errorMessage = <FormHelperText id="my-helper-text" style={{color: '#ff3f21'}}>Campo Obrigatório.</FormHelperText>;

interface Normalization {
    value: string;
    index: number;
    id: number | null;
}

export default function AlarmConditionTab({index,alarmSeveritiesList, normalization,alarmedName, normalName, alarmSoundProps, createEventProps, availabilityAlarmProps, alarmSeverity, alarm24hProps, setNormalizationCondition, setAlarmSeverityCondition, setAlarmedNameCondition, setNormalNameCondition, setDeleteItem, setAlarmSoundCondition, setCreateEventCondition, setAvailabilityAlarmCondition, setAlarm24hCondition}: any) {
    const [normalizationValue, setNormalizationValue] = useState(normalization?.value);
    const [alarmedNameValue, setAlarmedNameValue] = useState(alarmedName?.value);
    const [normalNameValue, setNormalNameValue] = useState(normalName?.value);
    const [alarmValue, setAlarmValue] = useState(alarmSeverity?.value);
    const [alarmSound, setAlarmSound] = useState(alarmSoundProps?.hasAlarmSound ?? false);
    const [createEvent, setCreateEvent] = useState(createEventProps?.createEvent ?? false);
    const [availabilityAlarm, setAvailabilityAlarm] = useState(availabilityAlarmProps?.availabilityAlarm ?? false);
    const [alarm24h, setAlarm24h] = useState(alarm24hProps?.alarm24h ?? false);

    function handleNormalization(value: any){
        const newNormalization: Normalization = { index: index, value, id: normalization && normalization?.id !== null ? normalization.id : null };
        setNormalizationCondition(newNormalization);
        setNormalizationValue(value);
    }

    function handleAlarm(value: any) {
        const newAlarm = {index: index, value, id: alarmSeverity && alarmSeverity?.id !== null ? normalization.id : null};
        setAlarmSeverityCondition(newAlarm);
        setAlarmValue(value);
    }
    function handleAlarmedName(value: any) {
        const newAlarm = {index: index, value, id: alarmedName && alarmedName?.id !== null ? alarmedName.id : null};
        setAlarmedNameCondition(newAlarm);
        setAlarmedNameValue(value);
    }

    function handleNormalName(value: any) {
        const newAlarm = {index: index, value, id: normalName && normalName?.id !== null ? normalName.id : null};
        setNormalNameCondition(newAlarm);
        setNormalNameValue(value);
    }

    function handleDeleteItem() {
        setDeleteItem(index);
    }

    function handleAlarmSound(event: React.SyntheticEvent<Element, Event>, checked: boolean) {
        setAlarmSound(checked);
        const newAlarm = {index: index, hasAlarmSound: checked, id: alarmSoundProps && alarmSoundProps?.id !== null ? alarmSoundProps.id : null};
        setAlarmSoundCondition(newAlarm);
    }

    function handleCreateEvent(event: React.SyntheticEvent<Element, Event>, checked: boolean) {
        setCreateEvent(checked);
        const newAlarm = {index: index, createEvent: checked, id: createEventProps && createEventProps?.id !== null ? createEventProps.id : null};
        setCreateEventCondition(newAlarm);
    }

    function handleAvailabilityAlarm(event: React.SyntheticEvent<Element, Event>, checked: boolean) {
        setAvailabilityAlarm(checked);
        const newAlarm = {index: index, availabilityAlarm: checked, id: availabilityAlarmProps && availabilityAlarmProps?.id !== null ? availabilityAlarmProps.id : null};
        setAvailabilityAlarmCondition(newAlarm);
    }

    function handleAlarm24h(event: React.SyntheticEvent<Element, Event>, checked: boolean) {
        setAlarm24h(checked);
        const newAlarm = {index: index, alarm24h: checked, id: alarm24hProps && alarm24hProps?.id !== null ? alarm24hProps.id : null};
        setAlarm24hCondition(newAlarm);
    }

    return (

        <Grid container style={{paddingTop: 27, justifyContent: "space-around"}}>
            <Grid item xs={12} md={6} xl={2}>
                <InputLabel id="class-name">Nome {TextRequired()}</InputLabel>
                <TextField
                    fullWidth
                    id="class-name"
                    variant="standard"
                    placeholder={"Nome do Estado Alarmado"}
                    helperText="Campo obrigatório."
                    onChange={(value) => handleAlarmedName(value.target.value)}
                    value={alarmedNameValue}
                />
            </Grid>
            <Grid item xs={12} md={6} xl={2}>
                <InputLabel id="class-name">Nome normal {TextRequired()}</InputLabel>
                <TextField
                    fullWidth
                    id="class-name"
                    variant="standard"
                    placeholder={"Nome no estado normal"}
                    helperText="Campo obrigatório."
                    onChange={(value) => handleNormalName(value.target.value)}
                    value={normalNameValue}
                />
            </Grid>
            <Grid item xs={12} md={6} xl={2}>
                <InputLabel id="selectTipoDado">Severidade {TextRequired()}</InputLabel>
                <Select
                    fullWidth
                    labelId="selectTipoDado"
                    id="selectTeleObjectType"
                    value={alarmValue}
                    label="Tipo de Dados"
                    onChange={(value) => handleAlarm(value.target.value as number)}
                    variant={"standard"}
                >
                    {
                        alarmSeveritiesList.map((type: any) => {
                            return (
                                <MenuItem key={type.id} value={type.id}>{type.name}</MenuItem>
                            )
                        })
                    }
                </Select>
                {
                    alarmSeverity === -1 && errorMessage
                }
            </Grid>
            <Grid item xs={12} md={6} xl={2}>
                <InputLabel id="class-normalization">Normalização {TextRequired()}</InputLabel>
                <TextField
                    fullWidth
                    error={normalizationValue === ""}
                    id="class-normalization"
                    variant="standard"
                    placeholder={"Normalização"}
                    onChange={(value) => handleNormalization(value.target.value)}
                    value={normalizationValue}
                    helperText="Campo obrigatório."
                />
            </Grid>
            <Grid item xs={12} md={6} xl={4}>
                <FormControl component="fieldset" fullWidth style={{marginTop: '6px'}} id={"class-alarm-son"+alarmedNameValue}>
                    <FormGroup aria-label="position" row>
                        <FormControlLabel
                            checked={alarmSound}
                            onChange={handleAlarmSound}
                            control={<Checkbox value={"true"}/>}
                            label="Alarme Sonoro"
                            labelPlacement="end"
                        />
                        <FormControlLabel
                            checked={createEvent}
                            onChange={handleCreateEvent}
                            control={<Checkbox value={"true"}/>}
                            label="Criar Evento"
                            labelPlacement="end"
                        />
                        <FormControlLabel
                            checked={availabilityAlarm}
                            onChange={handleAvailabilityAlarm}
                            control={<Checkbox value={"true"}/>}
                            label="Indisponibilidade"
                            labelPlacement="end"
                        />
                        <FormControlLabel
                            checked={alarm24h}
                            onChange={handleAlarm24h}
                            control={<Checkbox value={"true"}/>}
                            label="Monitorar 24h"
                            labelPlacement="end"
                        />
                        <IconButton 
                        name="delete" aria-label="Delete"
                        onClick={handleDeleteItem}
                        >
                        <Tooltip title="Excluir">
                            <Delete/>
                        </Tooltip>
                    </IconButton>
                </FormGroup>
                    
                </FormControl>
                
            </Grid>
        </Grid>
    )
}